module.exports = __webpack_public_path__ + "fonts/CooperBlack.3d64d132.woff";